import { useTranslation } from "react-i18next";

import { EReputationStatus } from "src/core/constants/eReputation";
import { MappedEntity } from "src/core/types/entity";

type EntityNoAlertMessageProps = {
  entity: MappedEntity;
};

export const EntityNoAlertMessage = ({ entity }: EntityNoAlertMessageProps) => {
  const { t } = useTranslation();

  if (!entity) return null;

  const showNoAlert =
    entity.pepStatus === EReputationStatus.NO_ALERT &&
    entity.sanctionStatus === EReputationStatus.NO_ALERT;

  const showNoAnalysis =
    entity.pepStatus === EReputationStatus.NO_ANALYSIS &&
    entity.sanctionStatus === EReputationStatus.NO_ANALYSIS;

  if (showNoAlert) {
    return <span className="p-20">{t("modal.entityDetails.noAlert")}</span>;
  }

  if (showNoAnalysis) {
    return <span className="p-20 text-red-medium">{t("modal.entityDetails.noAnalysis")}</span>;
  }

  return null;
};
